import { Nullable } from '@ps/utils';

export const BUYER_CONFIG_TOGGLE_KEYS = [
  // CPI MANAGEMENT
  'overridCmp',
  'enablePurePriceRates',

  // FIELDING
  'enableFeot',
  'enableMidwaySurvey',
  'enableTrafficChannels',
  'enableNestingQuotaGrouping',
  'enableNestingMultiQuota',
  'quotaThrottling',
  'enableSupplierGrouping',
  'enableAutoFieldManagement',
  'enableFMATimeBasedAutoPause',
  'enableAutomatedYieldManagement',
  'enableFMAAutoLaunchTCNearQuotaComplete',
  'enableFMADailyAutoLaunchTC',
  'enableSimulatedYieldManagement',
  'enableFMAStatusBasedAutoPause',
  'enableSupplierAllocationThrottling',

  // PROJECT MANAGEMENT
  'enableFilteringSortingBulkEdit',
  'reconciliations',
  'saveReconciliationOriginalFile',
  'enableDynamicDash',
  'enableBackEndSortFilter',
  'enableViewByPM',
  'enablePMRequired',
  'enableMandatoryPMEmailsInvoice',
  'enableMandatoryBillingNumber',
  'enableBillingNumberRules',
  'enablePaceTool',
  'enableDynamicReports',
  'enableAiDeliveryAssistance',
  'enableSurveyScoreCalculation',
  'enableRYGSurveyScore',

  // PROJECT SET UP
  'includeToo',
  'enableRespondentStatusFilter',
  'clickBal',
  'advanceTarget',
  'recontact',
  'uniqBuyerEntryLink',
  'enableTemplate',
  'enableMultiCountry',
  'enableMultiCountrySingleProjectView',
  'enableCreateSurveyV2',
  'enableSimilarSurveys',
  'enableClickToCalculate',
  'enableTracker',
  'enableBypassLOIThreshold',
  'customExclusionPeriod',
  'enablePermanentExclusion',
  'setPermanentExclusionOffByDefault',
  'enableSurveyTags',

  // QUALITY
  'enableBasicToken',
  'enableDataQualityQues',
  'enablePurescore5',
  'enableHealthMetrics',

  // OTHER
  'enableApiOnlySurveyCompletes',
  'cookieYesIntegration',
  'qbp',
  'qlc',
  'enableUrlTranfrmUsr',
  'enableHyperTarget',
  'enableScheduledLaunch',
  'enableScheduledPause',
  'enableSurveyExternalId',
  'enableSurveyDQBattery',
  'advanceStats',
  'enableQuestionLibrary',
  'enableInvoiceTab',
  'enablePriceRecomendation',
  'enableTargetMargin',
  'enableTargetMarginLaunchAll',
  'enableExtraCoreQualification',
  'shareMarketplaceInsights',
  'enableCRE',
  'enableMarginMax',
  'enablePureScoreAndRD',
  'enableProjectLevelDataQuality',
  'enableDefaultSettingsPureScore',
  'enableAdvanceFeasibilityDropDown',
  'enableLOIMultiplier',
  'disableSurveyAutoclose',
  'enableSurveyDetailsReport',
  'enablePrivacyPolicy',
  'enableTransactionTestingTool',
  'includeFusionPublisherId',
  'enableEntryLinkProfile',
  'enableSegmentationClass',
  'enableClassicSTR',
  'enableRealTimeNotification',
  'enableModularSurvey',
  'enableIntercomApp',
  'enablePriceOverrideFeasibilityMultiplier',
  'enableATConditionSearch',
  'enableCustomSupplierAllocationDefault',
  'enableDynamicBuyerDropThresholdLOI',
  'enableIPColumnSTCReport',
  'enableRangeQuotasDistribution',
  'enableNotificationCenter',
  'enablePlatformSwitcher',

  // CUSTOM COUNTRIES
  'enableBlockedCountries',
] as const;

export const MANDATORY_PM_EMAILS_INVOICE_TURNED_OFF_MESSAGE =
  'Feature Mandatory Project Manager Emails to the Invoice is turned off as Buyer invoice type is not PO or Project.';

export type BuyerConfigToggleKey = (typeof BUYER_CONFIG_TOGGLE_KEYS)[number];

export type BuyerConfigToggles = Record<BuyerConfigToggleKey, boolean>;

export interface BuyerConfigToggleChange {
  readonly config: BuyerConfigToggleKey;
  readonly enable: boolean;
}

export interface BuyerConfigSettingsForm {
  readonly configSettingsId: string;
  readonly toggles: BuyerConfigToggles;
  readonly defaultCountry: string;
  readonly blockedCountries: readonly string[];
  readonly purescoreToken: string;
  readonly exclusionPeriodDefault: Nullable<number>;
}

export interface BuyerConfigSettingsSavePayload {
  readonly configSettingsId: string;
  readonly buyerId: number;
  readonly changes: readonly BuyerConfigToggleChange[];
}

export interface BuyerCountrySettingsSavePayload {
  readonly buyerId: number;
  readonly defaultCountry?: string;
  readonly blockedCountries?: readonly string[];
  readonly exclusionPeriodDefault?: Nullable<number>;
}
